<template>
  <div class="h-full border-b outlets flex justify-between pb-4 mb-6">
    <div class="outlets__action mt-8" >
      <span v-if="action === 'create'">
        <i v-show="level !== 1" @click="remove" class="cursor-pointer el-icon-remove-outline text-2xl"></i>
      </span>
      <span v-else>
        <i v-if="isNewOutlets" @click="remove" class="cursor-pointer el-icon-remove-outline text-2xl"></i>
        <span v-else>
          <span v-if="!loading">
            <i v-show="!isNewOutlets" @click="deleteOutlet" class="cursor-pointer el-icon-delete text-red-500 text-2xl"></i>
          </span>
          <vue-loaders v-else name="line-scale-pulse-out-rapid" color="red" scale="0.5"></vue-loaders>
        </span>
      </span>
    </div>
    <div class="outlets__input mb-4">
      <label class="block text-gray-700 text-sm mb-1">
        Outlet
      </label>
      <el-select class="w-full" @change="quantityDisabled = false" v-model="outletId" placeholder="Select Outlets">
        <el-option
          v-for="outlet in outlets"
          :key="outlet.value"
          :label="outlet.label"
          :value="outlet.value">
        </el-option>
      </el-select>
      <p v-if="!$v.outletId.required" class="text-red-500 text-xs italic mt-1">Please select a value</p>
    </div>
    <div class="outlets__input mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-1">
        Quantity
      </label>
      <el-input  placeholder="e.g 200 " v-model="quantity"></el-input>
      <p v-if="!$v.quantity.integer" class="text-red-500 text-xs italic mt-1">Please provide only integers</p>
    </div>
    <div class="outlets__action mt-8">
      <i  v-show="count === level && $v.quantity.integer && (action === 'edit' && $v.outletId.required)" @click="add()" class="cursor-pointer el-icon-circle-plus-outline text-2xl"></i>
      <i  v-show="count === level && $v.quantity.integer && action === 'create'" @click="add()" class="cursor-pointer el-icon-circle-plus-outline text-2xl"></i>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import productForm from '../../../../helper/form-validations';

export default {
  name: 'Outlet',
  mixins: [validationMixin],
  validations: {
    ...productForm.outlet,
  },
  props: {
    count: {
      type: Number,
      required: true,
    },
    level: {
      type: Number,
      required: true,
    },
    action: {
      type: String,
      default: 'create',
    },
  },
  data() {
    return {
      quantityDisabled: true,
      loading: false,
    };
  },
  computed: {
    key() {
      return this.level - 1;
    },
    outletId: {
      get() {
        if (this.$store.state.InventoryModule.Products[this.action].outlets[this.key]) {
          return this.$store.state.InventoryModule.Products[this.action].outlets[this.key].outlet_id || null;
        }

        return null;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductMultipleData', {
          action: this.action, parent: 'outlets', key: this.key, property: 'outlet_id', payload: value,
        });
      },
    },
    quantity: {
      get() {
        if (this.$store.state.InventoryModule.Products[this.action].outlets[this.key]) {
          return this.$store.state.InventoryModule.Products[this.action].outlets[this.key].quantity || null;
        }

        return null;
      },
      set(value) {
        this.$store.commit('InventoryModule/Products/setProductMultipleData', {
          action: this.action, parent: 'outlets', key: this.key, property: 'quantity', payload: value,
        });
        this.$emit('isDirty', !this.$v.quantity.$invalid);
      },
    },
    outlets() {
      return this.$store.getters['OutletModule/outletsForSelect'];
    },
    isNewOutlets() {
      const outlets = this.$store.state.InventoryModule.Products[this.action].outlets[this.key];
      if (outlets && Object.keys(outlets).length > 0) {
        return !outlets.id;
      }

      return true;
    },
  },
  methods: {
    add() {
      this.$store.commit('InventoryModule/Products/setActionMultipleProperty', {
        action: this.action, parent: 'outlets', payload: { [this.level]: {} },
      });
      this.$emit('add');
    },
    remove() {
      this.$store.commit('InventoryModule/Products/removeProductMultipleData', {
        action: this.action, parent: 'outlets', key: this.key, index: this.level,
      });
      this.$emit('minus');
    },
    async deleteOutlet() {
      this.loading = true;
      const outletId = this.$store.state.InventoryModule.Products[this.action].outlets[this.key].id;
      try {
        await this.$store.dispatch('InventoryModule/Products/deleteItemOutlet', { outletId, productId: this.$route.params.id });
        await this.remove();
        this.$notify.success({
          title: 'Success',
          message: 'Outlet Successfully Deleted',
        });
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
  .outlets {
    .outlets__input {
      flex: 0 1 45%
    }

    .outlets__action {
      flex: 0 1 3%;
    }
  }
</style>
